export enum ELanguage {
  English = 'en',
  Thai = 'th'
}

export const SUPPORTED_LANGUAGES: ELanguage[] = [
  ELanguage.English,
  ELanguage.Thai
]
